import React, {Component} from "react";
import Select from "react-select";
import {helperFunctions as HF} from "helper/helperFunctions";
import {connect} from "react-redux";
import {Tooltip, OverlayTrigger} from 'react-bootstrap';
import {listActions} from "../../redux/actions/list-actions";
import {customSelectStyles} from "../ThemeComponents/selectStyles";
import {FiPlus} from 'react-icons/fi';

class Address extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addressObject: this.props.addressObject,
            states: [],
            formType: this.props.formTypePro || "",
            hideAddNewStateModal: true, //! Made true cuz of error in edit customer, original : this.props.hideAddNewStateModal || false
            childrens: []
        };
        this.handleChangeAddress = this.handleChangeAddress.bind(this);
        this.handleChangeAddressDropDown = this.handleChangeAddressDropDown.bind(
            this
        );
    }

    handleChangeAddress(e, parentObject) {
        const {name, value} = e.target;
        let updateAddress = {...this.state.addressObject};
        updateAddress[name] = value;
        this.setState({addressObject: updateAddress});
    }

    handleChangeAddressDropDown(selectedOptionType, info, parentObject) {
        if (info["name"] === "country") {
            this.setState(
                {
                    addressObject: {
                        ...this.state.addressObject,
                        country_id: selectedOptionType.value,
                        country: selectedOptionType.label,
                        create_address: true
                    }
                },
                () => {
                    !this.props.in_order ?
                        this.props.getListItemCall(selectedOptionType.value).then(res => {
                            this.setState({
                                childrens: res ? res.childrens : []
                            });
                        }) : null
                }
            );
        }

        if (info["name"] === "contact") {
            const contact = this.props.contacts.find(item => item.id === selectedOptionType.value);

            this.setState({
                    addressObject: {
                        ...this.state.addressObject,
                        selectedContact: selectedOptionType.value,
                        contact_name: selectedOptionType.label,
                        email: contact.email,
                        phone: contact.phone,
                        create_contact: 'false'
                    }
                },
                () => {
                    this.props.onContactDropdownChanged(contact);
                });
        }

        if (info["name"] === "state") {
            this.setState(
                {
                    addressObject: {
                        ...this.state.addressObject,
                        region_id: selectedOptionType.value,
                        region: selectedOptionType.label,
                        create_address: true
                    }
                });
        }
    }

    componentDidMount() {
        if (this.state.formType === "edit" && this.state.addressObject.country_id) {
            this.props.getListItemCall(this.state.addressObject.country_id).then(res => {
                this.setState({
                    childrens: res ? res.childrens : []
                });
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.addressObject !== prevState.addressObject) {
            this.props.returnState({
                address: this.state.addressObject
            });
        }
        if (this.props.addressObject !== prevProps.addressObject) {
            this.setState({
                addressObject: this.props.addressObject
            });
        }

        if (prevProps.addressObject.country_id !== this.props.addressObject.country_id && this.props.addressObject.country_id) {
            this.props.getListItemCall(this.props.addressObject.country_id).then(res => {
                this.setState({
                    childrens: res ? res.childrens : []
                });
            })
        }
    }

    getOptions(data) {
        if (data === undefined) {
            return [];
        }
        return data.map(({id, title}) => ({
            value: id,
            label: HF.Capitalize(title)
        }));
    }

    getContactOptions(data) {
        if (data === undefined) {
            return [];
        }
        return data.map(({id, first_name, last_name, email}) => ({
            value: id,
            label: HF.Capitalize(first_name) + " " + HF.Capitalize(last_name)
        }));
    }

    handleCompanyName = (e) => {
        this.setState({
            addressObject: {
                ...this.state.addressObject,
                customer: {
                    id: this.props.addressObject.customer.id,
                    title: e.target.value
                }
            }
        })
    }

    render() {
        const {addressObject} = this.state;
        const {childrens} = this.state;
        return (
            <React.Fragment>

                <div className="flexElem flexResponsive halfCols alignFlexCenter">
                    {
                        this.props.extraHtml &&
                        this.props.extraHtml
                    }
                    {addressObject && this.props.show_title &&
                    <React.Fragment>
                        <div
                            className="mt-md fieldWithIcon"
                            id={this.props.htmlElement + "title"}
                            style={{
                                marginLeft: this.props.in_order ? '' : '0',
                                marginRight: this.props.in_order ? '' : '0'
                            }}
                        >
                            <span className="fieldIcon userIcon"></span>


                            <input
                                type="text"
                                name="title"
                                placeholder="Title"
                                className="form-control"

                                value={
                                    addressObject.title
                                        ? addressObject.title
                                        : ""
                                }
                                onChange={event =>
                                    this.handleChangeAddress(event)
                                }
                                disabled={this.props.sameAsShippingProp || this.props.disable_order_detail}
                            />

                            <span className="customMsg">
                                    {
                                        this.props.validatorInstance.message(
                                            this.props.htmlElement + "title",
                                            addressObject.title,
                                            ["required"])
                                    }
                                </span>
                        </div>
                    </React.Fragment>
                    }
                </div>

                <div className="flexElem flexResponsive halfCols alignFlexCenter">
                    <div
                        className="mt-md fieldWithIcon"
                        id={this.props.htmlElement + "line1"}
                        style={{marginLeft: '0px', marginRight: '0px'}}
                    >
                        <span className="fieldIcon locationIcon"></span>
                        {addressObject && (
                            <input
                                type="text"
                                name="line1"
                                placeholder="Street Address"
                                className="form-control"

                                value={
                                    addressObject.line1
                                        ? addressObject.line1
                                        : ""
                                }
                                onChange={event =>
                                    this.handleChangeAddress(event)
                                }
                                disabled={this.props.sameAsShippingProp || this.props.disable_order_detail}
                            />
                        )}
                        {addressObject && this.props.requiredField.line1 && (
                            <span className="customMsg">
                                {this.props.validatorInstance.message(
                                    this.props.htmlElement + "Street",
                                    addressObject.line1,
                                    this.props.requiredField.line1
                                )}
                            </span>
                        )}
                    </div>
                </div>

                <div className="flexElem flexResponsive halfCols alignFlexCenter ">
                    <div
                        className="mt-md fieldWithIcon"
                        id={this.props.htmlElement + "Country"}
                    >
                        <span className="fieldIcon flagIcon"></span>
                        {addressObject && (
                            <React.Fragment>
                                <Select
                                    styles={customSelectStyles}
                                    value={HF.returnLabelWithValueCustom(
                                        addressObject.country_id,
                                        this.getOptions(this.props.countries)
                                    )}
                                    onChange={(event, info) =>
                                        this.handleChangeAddressDropDown(
                                            event,
                                            info
                                        )
                                    }
                                    options={this.getOptions(
                                        this.props.countries
                                    )}
                                    isSearchable={true}
                                    isMulti={false}
                                    name="country"
                                    isClearable={
                                        this.props.isClearableCountryPro
                                    }
                                    placeholder={"Country/Region"}
                                    isDisabled={this.props.sameAsShippingProp || this.props.disable_order_detail}
                                />
                            </React.Fragment>
                        )}
                        {addressObject &&
                        this.props.requiredField.country_id && (
                            <span className="customMsg">
                                    {this.props.validatorInstance.message(
                                        this.props.htmlElement + " country",
                                        addressObject.country_id,
                                        this.props.requiredField.country_id
                                    )}
                                </span>
                        )}
                    </div>
                    <div
                        className="mt-md fieldWithIcon"
                        id={this.props.htmlElement + "State"}
                    >
                        <div className="flexElem alignCenter">
                            <div style={{width: '100%'}}>
                                <span className="fieldIcon stateIcon"></span>
                                {addressObject && (
                                    <Select
                                        styles={customSelectStyles}
                                        value={HF.returnLabelWithValue(
                                            addressObject.region_id,
                                            this.getOptions(childrens)
                                        )}
                                        onChange={(event, info) =>
                                            this.handleChangeAddressDropDown(
                                                event,
                                                info
                                            )
                                        }
                                        options={this.getOptions(childrens)}
                                        isSearchable={true}
                                        isMulti={false}
                                        name="state"
                                        placeholder={"State/ Province/ Region"}
                                        isDisabled={this.props.sameAsShippingProp || this.props.disable_order_detail}
                                        id={this.props.address || 'states'}
                                    />
                                )}
                                {addressObject &&
                                this.props.requiredField.region_id && (
                                    <span className="customMsg">
                                            {this.props.validatorInstance.message(
                                                this.props.htmlElement + " state",
                                                addressObject.region_id,
                                                this.props.requiredField.region_id
                                            )}
                                        </span>
                                )}
                            </div>

                            {!this.state.hideAddNewStateModal &&
                            <div>
                                {addressObject.country_id &&
                                !this.props.shippingAddress && (
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip id="addNewState">Add New</Tooltip>
                                    }>
                                                <span
                                                    className="addNewState"
                                                    onClick={() =>
                                                        this.props.openAddNewTagForm(
                                                            "region",
                                                            "New State",
                                                            4
                                                        )
                                                    }
                                                >
                                                    <FiPlus/>
                                                </span>
                                    </OverlayTrigger>
                                )}
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <div className="flexElem flexResponsive halfCols alignFlexCenter">
                    <div
                        className="mt-md fieldWithIcon"
                        ref={this.props.htmlElement + "City"}
                    >
                        <span className="fieldIcon locationIcon"></span>
                        {addressObject && (
                            <input
                                type="text"
                                name="city"
                                className="form-control"
                                placeholder="City"
                                value={
                                    addressObject.city ? addressObject.city : ""
                                }
                                onChange={event =>
                                    this.handleChangeAddress(event)
                                }
                                disabled={this.props.sameAsShippingProp || this.props.disable_order_detail}
                            />
                        )}
                    </div>

                    <div
                        className="mt-md fieldWithIcon"
                        style={{width: "100%"}}
                    >
                        <span className="fieldIcon zipIcon"></span>
                        {addressObject && (
                            <input
                                type="text"
                                id={this.props.htmlElement + "Zip"}
                                placeholder="Zip / Postal Code"
                                name="zip_post_code"
                                className="form-control"
                                value={
                                    addressObject.zip_post_code
                                        ? addressObject.zip_post_code
                                        : ""
                                }
                                onChange={event =>
                                    this.handleChangeAddress(event)
                                }
                                disabled={this.props.sameAsShippingProp || this.props.disable_order_detail}
                            />
                        )}
                    </div>


                </div>
                {/* {
                    addressObject && addressObject.customer && addressObject.customer.id &&
                    <div
                        className="mt-md fieldWithIcon"
                        style={{ width: "100%" }}
                    >
                        <span className="fieldIcon userIcon"></span>
                        {addressObject && (
                            <input
                                type="text"
                                id={this.props.htmlElement + "company_name"}
                                placeholder="Company Name"
                                name="title"
                                className="form-control"
                                value={
                                    addressObject.customer
                                        ? addressObject.customer.title
                                        : ""
                                }
                                onChange={this.handleCompanyName}
                            />
                        )}
                    </div>
                } */}
                {this.props.shippingAddress && (
                    <div className="flexElem flexResponsive halfCols alignFlexCenter">
                        <div
                            className="mt-md fieldWithIcon"
                            id={this.props.htmlElement + "Country"}
                        >
                            <span className="fieldIcon flagIcon"></span>
                            <Select
                                styles={customSelectStyles}
                                value={HF.returnLabelWithValue(
                                    addressObject.selectedContact,
                                    this.getContactOptions(this.props.contacts)
                                )}
                                onChange={(event, info) =>
                                    this.handleChangeAddressDropDown(
                                        event,
                                        info
                                    )
                                }
                                options={this.getContactOptions(
                                    this.props.contacts
                                )}
                                isSearchable={true}
                                isMulti={false}
                                name="contact"
                                isClearable={this.props.isClearableCountryPro}
                                placeholder={"Select Contact"}
                                isDisabled={this.props.sameAsShippingProp || this.props.disable_order_detail}
                            />
                            {this.props.requiredField.selectedContact && (
                                <span className="customMsg">
                                    {this.props.validatorInstance.message(
                                        this.props.htmlElement +
                                        "Select Contact",
                                        addressObject.selectedContact,
                                        this.props.requiredField.selectedContact
                                    )}
                                </span>
                            )}
                        </div>
                        <div
                            className="mt-md fieldWithIcon"
                            id={this.props.htmlElement + "contact_name"}
                        >
                            <span className="fieldIcon locationIcon"></span>
                            <input
                                type="text"
                                name="contact_name"
                                className="form-control"
                                placeholder="Contact Name"
                                value={
                                    addressObject.contact_name
                                        ? addressObject.contact_name
                                        : ""
                                }
                                onChange={event =>
                                    this.handleChangeAddress(event)
                                }
                                disabled={this.props.sameAsShippingProp || this.props.disable_order_detail}
                            />
                            {this.props.requiredField.contact_name && (
                                <span className="customMsg">
                                    {this.props.validatorInstance.message(
                                        this.props.htmlElement + "Contact Name",
                                        addressObject.contact_name,
                                        this.props.requiredField.contact_name
                                    )}
                                </span>
                            )}
                        </div>
                    </div>
                )}

                {this.props.shippingAddress && (
                    <div className="flexElem flexResponsive halfCols alignFlexCenter">
                        <div
                            className="mt-md fieldWithIcon"
                            id={this.props.htmlElement + "phone"}
                        >
                            <span className="fieldIcon userIcon"></span>
                            <input
                                type="text"
                                name="phone"
                                className="form-control"
                                placeholder="Phone"
                                value={
                                    addressObject.phone
                                        ? addressObject.phone
                                        : ""
                                }
                                onChange={event =>
                                    this.handleChangeAddress(event)
                                }
                                disabled={this.props.sameAsShippingProp || this.props.disable_order_detail}
                            />
                            {this.props.requiredField.phone && (
                                <span className="customMsg">
                                    {this.props.validatorInstance.message(
                                        "Contact phone",
                                        addressObject.phone,
                                        this.props.requiredField.phone
                                    )}
                                </span>
                            )}
                        </div>
                        <div
                            className="mt-md fieldWithIcon"
                            id={this.props.htmlElement + "email"}
                        >
                            <span className="fieldIcon emailIcon"></span>
                            <input
                                type="text"
                                name="email"
                                className="form-control"
                                placeholder="Email"
                                value={
                                    addressObject.email
                                        ? addressObject.email
                                        : ""
                                }
                                onChange={event =>
                                    this.handleChangeAddress(event)
                                }
                                disabled={this.props.sameAsShippingProp || this.props.disable_order_detail}
                            />
                            {this.props.requiredField.email && (
                                <span className="customMsg">
                                    {this.props.validatorInstance.message(
                                        this.props.htmlElement + "email",
                                        addressObject.email,
                                        this.props.requiredField.email
                                    )}
                                </span>
                            )}
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

Address.defaultProps = {
    show_title: true
};

const mapDispatchToProps = dispatch => {
    return {
        getListItemCall: id => {
            return dispatch(listActions.getListItem(id));
        }
    };
};

function mapStateToProps(state) {
    const {childrens} = state.listReducer;
    return {
        childrens
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Address);



// WEBPACK FOOTER //
// ./src/components/ThemeComponents/Address.jsx